import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OfferRequest } from '@models/offer/offerRequest.model';
import { environment } from '../../../environments/environment';
import { Task } from '@app/models/task/task.model';
import { Offer } from '@app/models/offer/offer.model';

@Injectable()
export class OfferRequestService {
  private baseHref = `${environment.apiUrl}/offer-requests`;

  constructor(private http: HttpClient) {}

  createOfferRequest(offerRequestData: OfferRequest): Observable<OfferRequest> {
    return this.http.post<OfferRequest>(this.baseHref, offerRequestData);
  }

  getOfferRequestsByConversation(conversationId): Observable<OfferRequest[]> {
    const url = `${this.baseHref}/conversation/${conversationId}`;
    return this.http.get<OfferRequest[]>(url);
  }

  withdrawOfferRequest(offerRequestId: number): Observable<any> {
    const url = `${this.baseHref}/withdraw/${offerRequestId}`;
    return this.http.get<any>(url);
  }

  getOfferRequestById(offerRequestId: number): Observable<OfferRequest> {
    const url = `${this.baseHref}/${offerRequestId}`;
    return this.http.get<OfferRequest>(url);
  }

  makeOffer(
    offerRequestId: number,
    priceBid: number,
    offerMessage: string,
  ): Observable<any> {
    const url = `${this.baseHref}/${offerRequestId}/make-offer`;
    return this.http.put<any>(url, { priceBid, offerMessage });
  }

  withdrawOffer(offerRequestId: number): Observable<any> {
    const url = `${this.baseHref}/${offerRequestId}/withdraw-offer`;
    return this.http.get<any>(url);
  }

  editOfferRequest(offerRequestData: OfferRequest): Observable<OfferRequest> {
    return this.http.put<OfferRequest>(
      `${this.baseHref}/${offerRequestData.id}`,
      offerRequestData,
    );
  }

  // return type is an object with two keys: task and offer
  acceptOfferRequest(
    taskData: Task,
    offerData: Offer,
    offerRequestId: number,
  ): Observable<{ task: Task; offer: Offer }> {
    return this.http.post<{ task: Task; offer: Offer }>(
      `${this.baseHref}/accept`,
      { taskData, offerData, offerRequestId }
    );
  }
}
